<template>
  <div>
    <ServiceProviderFilters />
    <v-card outlined>
      <v-data-table
        @dblclick:row="goToServiceProviderDetails"
        :loading-text="$t('appointment.table.loading')"
        :no-data-text="$t('appointment.table.noData')"
        :items="serviceProviders"
        :items-per-page="itemsPerPage"
        :headers="serviceProviderHeaders"
        :loading="isLoading"
        class="clickable"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:[`item.document`]="{ item }">
          {{ formatDocument(item.document) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <ServiceProviderListMenu :serviceProvider="item" />
        </template>
      </v-data-table>
    </v-card>
    <h-pagination :fetch="listServiceProviders" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { serviceProviderHeaders } from '../listHeaders'
import { formatDocument } from '../../../util/document'

import ServiceProviderListMenu from '../fragments/ServiceProviderListMenu'
import ServiceProviderFilters from './ServiceProviderFilters'

export default {
  name: 'ServiceProviderList',

  components: {
    ServiceProviderListMenu,
    ServiceProviderFilters,
  },

  computed: {
    ...mapGetters(['isLoading', 'serviceProviders', 'itemsPerPage']),
  },

  methods: {
    ...mapActions(['listServiceProviders']),

    goToServiceProviderDetails(event, { item: serviceProvider }) {
      this.$router.push(`/service-providers/${serviceProvider.id}`)
    },
  },

  data() {
    return {
      serviceProviderHeaders,
      formatDocument,
    }
  },

  mounted() {
    this.listServiceProviders()
  }
}
</script>
